export enum FieldWebInputTypeEnum {
  string = 'string',
  web = 'web',
  email = 'email',
  byte = 'byte',
  short = 'short',
  int = 'int',
  double = 'double',
  long = 'long',
  checkbox = 'checkbox',
  notes = 'notes',
  combobox = 'combobox',
  richtext = 'richtext',
  date = 'date',
  month = 'month',
  time = 'time',
  percent = 'percent',
}

export type FieldWebInputType = `${FieldWebInputTypeEnum}`;
